import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Logo from '@/components/Logo';

export default function NotFoundPage() {
  const [code, setCode] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (code.trim()) {
      navigate(`/${code.trim().toUpperCase()}`);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center px-4 pt-52">
      <div className="text-center max-w-md w-full">
        {!isHomePage && (
          <>
            <div className="mb-4">
              <Logo fontSize={40} />
            </div>
            <div className="text-6xl mb-4">404</div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Page Not Found</h1>
            <p className="text-gray-600 mb-6">
              This page doesn't exist. Make sure you have the right link.
            </p>
          </>
        )}
        {isHomePage && (
          <div>
            <Logo fontSize={48} showTagline />
            {/* Placeholder lines to match JoinPage spacing */}
            <p className="text-gray-900 font-medium mt-2">&nbsp;</p>
            <p className="text-gray-500 text-sm">&nbsp;</p>
          </div>
        )}
        <form onSubmit={handleSubmit} className="mb-4 mt-8">
          <label className="block text-sm text-gray-500 mb-2">
            Have an event code? Enter it below:
          </label>
          <div className="flex gap-2">
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              placeholder="ABCD1234"
              maxLength={8}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-center text-lg tracking-widest uppercase focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              type="submit"
              disabled={!code.trim()}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Join
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
